import {useEffect} from 'react'
import {TRACKING_PAGE} from '@utils/Const'
import appRequest from '@apis/app'

const TrackingPage = () => {
  if (process.env.REACT_APP_ENV === 'dev') {
    return <div />
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        let pathname = window.location.pathname || ''

        if (pathname !== '/') {
          pathname = pathname.replace(/\/+$/, '')
        }

        const foundKey = Object.entries(TRACKING_PAGE).find(
          ([_, value]) => value === pathname,
        )?.[0]

        const params = {
          screen: foundKey || pathname,
        }

        await appRequest.trackingPage(params)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }

    fetchData()
    const interval = setInterval(fetchData, 10000)

    return () => clearInterval(interval)
  }, [])

  return <div />
}

export default TrackingPage
